var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKnowHow = function SvgKnowHow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M123.962 168.763c-21.204 0-42.408-8.07-58.55-24.213a83.5 83.5 0 0 1-10.098-12.226l.744-.502a82.5 82.5 0 0 0 9.989 12.094c31.933 31.933 83.896 31.931 115.828-.003 31.935-31.933 31.935-83.894 0-115.826-31.933-31.935-83.896-31.933-115.828 0a81.81 81.81 0 0 0-18.044 88.608l-.831.337a82.7 82.7 0 0 1 18.24-89.583c32.286-32.283 84.816-32.281 117.101 0 32.281 32.286 32.281 84.817 0 117.099-16.143 16.142-37.348 24.215-58.551 24.215"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.92 27.614 30.018 30.014-.636.636L51.284 28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.099 29.773c-3.23-.004-5.856-2.631-5.854-5.859a5.82 5.82 0 0 1 1.71-4.142 5.8 5.8 0 0 1 4.135-1.716c3.237 0 5.866 2.628 5.866 5.857a5.8 5.8 0 0 1-1.715 4.141 5.8 5.8 0 0 1-4.142 1.719m-.002-10.816c-1.328 0-2.57.515-3.505 1.452a4.91 4.91 0 0 0-1.449 3.505 4.963 4.963 0 0 0 4.956 4.959c1.325 0 2.57-.516 3.506-1.452a4.96 4.96 0 0 0-3.508-8.464"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m193.968 25.3.637.636-30.015 30.015-.637-.636z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 27.974a5.86 5.86 0 0 1-5.856-5.858 5.8 5.8 0 0 1 1.715-4.137 5.82 5.82 0 0 1 4.145-1.715c1.564 0 3.034.607 4.141 1.715a5.8 5.8 0 0 1 1.709 4.137c-.002 3.231-2.628 5.858-5.854 5.858m.005-10.817a4.95 4.95 0 0 0-3.512 1.453 4.93 4.93 0 0 0-1.453 3.505 4.967 4.967 0 0 0 4.96 4.96 4.964 4.964 0 0 0 4.955-4.96 4.91 4.91 0 0 0-1.451-3.505 4.92 4.92 0 0 0-3.499-1.453"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.807 132.523h-36.26c-4.44 0-8.052-3.613-8.052-8.054s3.612-8.05 8.054-8.055h34.859a1.437 1.437 0 0 1 1.427 1.426 1.425 1.425 0 0 1-1.423 1.423l-6.063-.002a.235.235 0 0 0 .005.47l.404-.002h7.79a1.437 1.437 0 0 1 1.427 1.423 1.43 1.43 0 0 1-1.425 1.426l-9.063.002a.24.24 0 0 0-.171.067.24.24 0 0 0-.067.168c0 .129.105.232.235.232l.855-.002 17.015-.003a1.43 1.43 0 0 1 1.425 1.426 1.437 1.437 0 0 1-1.425 1.426l-17.533-.004a.23.23 0 0 0-.232.232c0 .13.106.237.235.237l10.511-.002a1.433 1.433 0 0 1 1.427 1.424 1.435 1.435 0 0 1-1.421 1.426l-9.954-.006a.243.243 0 0 0-.231.234c0 .133.102.236.232.236l.951.002 6.471-.002a1.426 1.426 0 0 1-.003 2.852m-36.258-15.209c-3.946.002-7.155 3.211-7.155 7.155s3.208 7.154 7.153 7.154h36.26a.53.53 0 0 0 .526-.526.524.524 0 0 0-.526-.524l-6.883.002-.536-.004a1.137 1.137 0 0 1-1.13-1.132 1.14 1.14 0 0 1 1.131-1.136l.497.008h9.451a.53.53 0 0 0 .526-.528.53.53 0 0 0-.53-.525l-10.509.002a1.135 1.135 0 0 1 0-2.268l.52.005 17.009.002a.535.535 0 0 0 .53-.533.53.53 0 0 0-.531-.524l-17.867.007a1.137 1.137 0 0 1-.805-1.935c.214-.211.498-.33.801-.33l.23-.002h8.84a.527.527 0 1 0-.003-1.051h-7.785l-.407.002a1.144 1.144 0 0 1-1.137-1.13 1.146 1.146 0 0 1 1.132-1.14l6.062.007a.53.53 0 0 0 .524-.528.534.534 0 0 0-.529-.526H44.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.807 132.523h-36.26c-4.44 0-8.052-3.613-8.052-8.054s3.612-8.05 8.054-8.055h34.859a1.437 1.437 0 0 1 1.427 1.426 1.425 1.425 0 0 1-1.423 1.423l-6.063-.002a.235.235 0 0 0 .005.47l.404-.002h7.79a1.437 1.437 0 0 1 1.427 1.423 1.43 1.43 0 0 1-1.425 1.426l-9.063.002a.24.24 0 0 0-.171.067.24.24 0 0 0-.067.168c0 .129.105.232.235.232l.855-.002 17.015-.003a1.43 1.43 0 0 1 1.425 1.426 1.437 1.437 0 0 1-1.425 1.426l-17.533-.004a.23.23 0 0 0-.232.232c0 .13.106.237.235.237l10.511-.002a1.433 1.433 0 0 1 1.427 1.424 1.435 1.435 0 0 1-1.421 1.426l-9.954-.006a.243.243 0 0 0-.231.234c0 .133.102.236.232.236l.951.002 6.471-.002a1.426 1.426 0 0 1-.003 2.852m-36.258-15.209c-3.946.002-7.155 3.211-7.155 7.155s3.208 7.154 7.153 7.154h36.26a.53.53 0 0 0 .526-.526.524.524 0 0 0-.526-.524l-6.883.002-.536-.004a1.137 1.137 0 0 1-1.13-1.132 1.14 1.14 0 0 1 1.131-1.136l.497.008h9.451a.53.53 0 0 0 .526-.528.53.53 0 0 0-.53-.525l-10.509.002a1.135 1.135 0 0 1 0-2.268l.52.005 17.009.002a.535.535 0 0 0 .53-.533.53.53 0 0 0-.531-.524l-17.867.007a1.137 1.137 0 0 1-.805-1.935c.214-.211.498-.33.801-.33l.23-.002h8.84a.527.527 0 1 0-.003-1.051h-7.785l-.407.002a1.144 1.144 0 0 1-1.137-1.13 1.146 1.146 0 0 1 1.132-1.14l6.062.007a.53.53 0 0 0 .524-.528.534.534 0 0 0-.529-.526H44.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.568 129.371a4.905 4.905 0 0 1-4.901-4.901c0-2.702 2.199-4.9 4.9-4.9a4.906 4.906 0 0 1 4.901 4.9 4.904 4.904 0 0 1-4.9 4.901m.003-8.902a4.007 4.007 0 0 0-4.006 4.001c0 2.208 1.796 4.002 4.003 4.002s4.002-1.794 4.002-4.002a4.004 4.004 0 0 0-3.999-4.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.568 129.371a4.905 4.905 0 0 1-4.901-4.901c0-2.702 2.199-4.9 4.9-4.9a4.906 4.906 0 0 1 4.901 4.9 4.904 4.904 0 0 1-4.9 4.901m.003-8.902a4.007 4.007 0 0 0-4.006 4.001c0 2.208 1.796 4.002 4.003 4.002s4.002-1.794 4.002-4.002a4.004 4.004 0 0 0-3.999-4.001M59.382 129.376a4.92 4.92 0 0 1-4.903-4.906 4.91 4.91 0 0 1 4.9-4.9 4.907 4.907 0 0 1 4.906 4.9 4.916 4.916 0 0 1-4.903 4.906m.004-8.907a4.013 4.013 0 0 0-4.009 4.001 4.02 4.02 0 0 0 4.005 4.007 4.014 4.014 0 0 0 4.004-4.007 4.006 4.006 0 0 0-4-4.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.382 129.376a4.92 4.92 0 0 1-4.903-4.906 4.91 4.91 0 0 1 4.9-4.9 4.907 4.907 0 0 1 4.906 4.9 4.916 4.916 0 0 1-4.903 4.906m.004-8.907a4.013 4.013 0 0 0-4.009 4.001 4.02 4.02 0 0 0 4.005 4.007 4.014 4.014 0 0 0 4.004-4.007 4.006 4.006 0 0 0-4-4.001M44.568 127.101a2.62 2.62 0 0 1-1.861-.771 2.6 2.6 0 0 1-.769-1.86 2.625 2.625 0 0 1 2.632-2.63 2.64 2.64 0 0 1 2.629 2.628 2.635 2.635 0 0 1-2.631 2.633m.003-4.362c-.465 0-.902.179-1.228.509a1.7 1.7 0 0 0-.506 1.222c0 .464.179.897.506 1.226.326.327.762.509 1.226.509.955 0 1.732-.778 1.734-1.734a1.74 1.74 0 0 0-1.732-1.732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.568 127.101a2.62 2.62 0 0 1-1.861-.771 2.6 2.6 0 0 1-.769-1.86 2.625 2.625 0 0 1 2.632-2.63 2.64 2.64 0 0 1 2.629 2.628 2.635 2.635 0 0 1-2.631 2.633m.003-4.362c-.465 0-.902.179-1.228.509a1.7 1.7 0 0 0-.506 1.222c0 .464.179.897.506 1.226.326.327.762.509 1.226.509.955 0 1.732-.778 1.734-1.734a1.74 1.74 0 0 0-1.732-1.732M59.382 127.101a2.636 2.636 0 0 1-2.63-2.631 2.64 2.64 0 0 1 2.63-2.63c1.453 0 2.632 1.18 2.632 2.63s-1.18 2.631-2.632 2.631m0-4.362c-.952 0-1.729.774-1.733 1.73a1.74 1.74 0 0 0 1.733 1.734 1.733 1.733 0 1 0 0-3.464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.382 127.101a2.636 2.636 0 0 1-2.63-2.631 2.64 2.64 0 0 1 2.63-2.63c1.453 0 2.632 1.18 2.632 2.63s-1.18 2.631-2.632 2.631m0-4.362c-.952 0-1.729.774-1.733 1.73a1.74 1.74 0 0 0 1.733 1.734 1.733 1.733 0 1 0 0-3.464"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__a",
    x1: 119.886,
    x2: 173.773,
    y1: 39.737,
    y2: 129.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__a)",
    d: "M122.879 54.572h-.002a7.48 7.48 0 0 1-5.307-2.195 7.47 7.47 0 0 1-2.197-5.313l.003-4.639c0-4.137 3.366-7.504 7.503-7.506 4.142.002 7.51 3.369 7.51 7.504l-.006 4.647c0 1.997-.78 3.882-2.196 5.304a7.47 7.47 0 0 1-5.308 2.198m.001-16.06a3.92 3.92 0 0 0-3.912 3.914l-.001 4.641a3.88 3.88 0 0 0 1.144 2.766c1.476 1.479 4.051 1.484 5.535 0a3.9 3.9 0 0 0 1.146-2.766l.005-4.645a3.92 3.92 0 0 0-3.917-3.91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__b",
    x1: 78.913,
    x2: 97.2,
    y1: 62.994,
    y2: 62.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__b)",
    d: "M89.695 72.143a7.45 7.45 0 0 1-5.304-2.197l-3.282-3.289a7.46 7.46 0 0 1-2.197-5.303 7.48 7.48 0 0 1 2.197-5.313 7.48 7.48 0 0 1 5.311-2.196c2.003 0 3.887.782 5.305 2.196l3.282 3.285c2.924 2.927 2.924 7.688 0 10.617a7.47 7.47 0 0 1-5.312 2.2M86.42 57.438c-1.045 0-2.03.406-2.769 1.146a3.9 3.9 0 0 0-1.146 2.77 3.89 3.89 0 0 0 1.146 2.763l3.283 3.29c1.473 1.474 4.054 1.474 5.531-.002a3.92 3.92 0 0 0 0-5.535l-3.282-3.285a3.88 3.88 0 0 0-2.763-1.147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__c",
    x1: 148.554,
    x2: 166.849,
    y1: 62.992,
    y2: 62.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__c)",
    d: "M156.061 72.135a7.45 7.45 0 0 1-5.31-2.195 7.46 7.46 0 0 1-2.197-5.308 7.44 7.44 0 0 1 2.196-5.306l3.287-3.285a7.48 7.48 0 0 1 5.306-2.191c2.004 0 3.89.777 5.307 2.191a7.47 7.47 0 0 1 2.199 5.313 7.44 7.44 0 0 1-2.198 5.305l-3.285 3.281a7.46 7.46 0 0 1-5.305 2.195m3.283-14.695a3.9 3.9 0 0 0-2.768 1.147l-3.287 3.281a3.91 3.91 0 0 0 .003 5.528c1.477 1.476 4.059 1.482 5.532 0l3.285-3.279a3.88 3.88 0 0 0 1.147-2.765 3.89 3.89 0 0 0-1.148-2.768 3.9 3.9 0 0 0-2.764-1.144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__d",
    x1: 91.37,
    x2: 145.279,
    y1: 56.749,
    y2: 146.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__d)",
    d: "M126.583 111.289h-7.407a1.798 1.798 0 0 1 0-3.594h7.407a1.797 1.797 0 0 1 0 3.594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__e",
    x1: 88.4,
    x2: 142.29,
    y1: 58.548,
    y2: 148.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__e)",
    d: "M126.583 118.059h-7.407a1.797 1.797 0 0 1 0-3.594h7.407a1.798 1.798 0 0 1 0 3.594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__f",
    x1: 85.421,
    x2: 139.31,
    y1: 60.332,
    y2: 150.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__f)",
    d: "M126.583 124.83h-7.407a1.798 1.798 0 0 1 0-3.594h7.407a1.797 1.797 0 0 1 0 3.594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__g",
    x1: 99.416,
    x2: 153.308,
    y1: 51.965,
    y2: 142.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__g)",
    d: "M126.063 133.067h-6.366c-4.951 0-8.982-4.031-8.982-8.981v-18.06c-7.93-4.423-12.809-12.668-12.809-21.782 0-13.768 11.204-24.967 24.975-24.967s24.975 11.199 24.975 24.967c0 9.112-4.877 17.359-12.81 21.779v18.063c-.001 4.95-4.03 8.981-8.983 8.981m-3.183-70.198c-11.791 0-21.381 9.588-21.381 21.375 0 8.121 4.528 15.437 11.817 19.098l.99.493v20.251a5.395 5.395 0 0 0 5.39 5.389h6.366a5.395 5.395 0 0 0 5.39-5.389v-20.251l.991-.498c7.291-3.658 11.818-10.972 11.818-19.093.001-11.787-9.59-21.375-21.381-21.375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__h",
    x1: 103.132,
    x2: 157.026,
    y1: 49.743,
    y2: 139.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__h)",
    d: "M122.879 89.445c-4.09 0-7.419-3.328-7.419-7.42a1.796 1.796 0 0 1 3.592 0 3.828 3.828 0 0 0 7.656 0 1.795 1.795 0 1 1 3.591 0c0 4.092-3.327 7.42-7.42 7.42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "know-how_svg__i",
    x1: 98.051,
    x2: 151.949,
    y1: 52.773,
    y2: 142.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#know-how_svg__i)",
    d: "M122.879 102.813a1.796 1.796 0 0 1-1.796-1.798V87.652a1.797 1.797 0 1 1 3.593 0v13.362c0 .994-.806 1.799-1.797 1.799"
  })));
};
export default SvgKnowHow;